import React, { FC, useCallback } from 'react';
import { Button, Result } from 'antd';
import { useHistory } from 'react-router-dom';

const Index: FC = () => {
  const history = useHistory();

  const handleClick = useCallback(() => history.push('/'), [history]);

  return (
    <div className='w-full h-full flex items-center justify-center'>
      <Result
        status='404'
        title='404'
        subTitle='Sorry, the page you visited does not exist.'
        extra={
          <Button type='primary' onClick={handleClick}>
            Next
          </Button>
        }
      />
    </div>
  );
};

export default Index;
